/**
 * Utility function to convert enum values to user-friendly labels
 * Converts UPPER_SNAKE_CASE to Title Case
 * @param enumValue - The enum value to format
 * @returns Formatted string with proper capitalization
 */
export const formatEnumToLabel = (enumValue: string): string => {
  return enumValue
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
